import { TrainingModule } from "../components/training/training-module";
import { createFileRoute, notFound, redirect } from "@tanstack/react-router";
import { loadTraining } from "../server/training";
import { creatorPageHead, shellFrom, withStylesheet } from "../lib/head";
import { useShell } from "../lib/document-route";
import { DocumentContent } from "../components/document-content";
import trainingStyles from "../styles/training.css?url";

export const Route = createFileRoute("/training")({
  loader: async () => {
    const data = await loadTraining();
    if (data.kind === "missing") throw notFound();
    if (data.kind === "redirect") throw redirect({ href: data.to, statusCode: 302 });
    return data;
  },
  head: ({ matches, loaderData }) => {
    const shell = shellFrom(matches);
    return shell && loaderData
      ? withStylesheet(
          creatorPageHead(shell, {
            pathname: "/training",
            title: `${loaderData.catalog.title} | ${shell.creator.name}`,
            description: loaderData.catalog.intro,
          }),
          trainingStyles,
        )
      : {};
  },
  component: TrainingPage,
});

function TrainingPage() {
  const data = Route.useLoaderData();
  const shell = useShell();
  const content = (
    <TrainingModule creatorId={shell.creator.id} initial={data.catalog} preview={data.preview} />
  );
  return data.kind === "page" ? (
    <DocumentContent data={data} shell={shell} builtIn={content} />
  ) : (
    content
  );
}
